import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setInvoiceModal, setInvoiceInfoModal } from '../actions/modalActions'
import { getTranslation } from '../../actions/dataActions'
import { createInvoice, getOriginalInvoice } from '../../actions/invoiceActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import Ink from 'react-ink';
import * as resource from '../../constants/Resources'
import { setMessageModal } from '../../actions/generalActions'
import PropTypes from 'prop-types';

class InvoiceModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            receipts: [],
            checkedItems: [],
            selectedStoreId: '',
            selectedCompanyId: ''
        };

        this.closeWindow = this.closeWindow.bind(this);
        this.invoiceAll = this.invoiceAll.bind(this);
        this.invoiceSelection = this.invoiceSelection.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleStoreChange = this.handleStoreChange.bind(this);
        this.handleCompanyChange = this.handleCompanyChange.bind(this);
    }

    componentDidMount() {
        this.applyDefaultsFromPos();
    }

    componentDidUpdate(prevProps, prevState) {
        const openedNow = !prevProps.invoiceModal.show && this.props.invoiceModal.show;
        const posChanged = prevProps.posId !== this.props.posId;

        if (openedNow || posChanged) {
            this.applyDefaultsFromPos();
        }

        if (prevState.selectedStoreId !== this.state.selectedStoreId || prevState.selectedCompanyId !== this.state.selectedCompanyId) {
            this.syncCheckedItemsWithVisibleReceipts();
        }
    }

    closeWindow() {
        this.props.setInvoiceModal(false, 100, []);
        this.applyDefaultsFromPos();
    }

    invoiceAll() {
        const allReceiptIds = this.getFilteredReceipts().map(rec => rec.ReceiptId.toString());
        this.setState({ checkedItems: allReceiptIds }, () => {
            this.processInvoices();
        });
    }

    invoiceSelection() {
        this.processInvoices();
    }

    processInvoices() {
        var receiptsToInvoice = [];
        this.getFilteredReceipts().forEach(rec => {
            if (this.state.checkedItems.includes(rec.ReceiptId.toString())) {
                receiptsToInvoice.push(rec);
            }
        });

        let credits = receiptsToInvoice.filter(rec => rec.Credit === true);
        let invoices = receiptsToInvoice.filter(rec => !rec.Credit);

        if (credits.length > 0 && invoices.length > 0) {
            this.props.setMessageModal(true, this.props.getTranslation(resource.CREDIT_MIXED_NOT_ALLOWED));
            return;
        }

        if (credits.length > 1) {
            this.props.setMessageModal(true, this.props.getTranslation(resource.CREDIT_ONLY_ONE_ALLOWED));
            return;
        }

        const isCredit = credits.length === 1;

        this.props.setInvoiceInfoModal(
            true,
            isCredit,
            (originalInvoiceNumber, reference) => {
                if (isCredit) {
                    if (!originalInvoiceNumber || originalInvoiceNumber.trim() === "") {
                        this.props.setMessageModal(true, this.props.getTranslation(resource.NOT_VALID_INVOICENUMBER));
                        return;
                    }
                    const customerId = credits[0].CustomerId;
                    this.props.getOriginalInvoice(
                        customerId,
                        originalInvoiceNumber.trim(),
                        (invoice) => {
                            if (!invoice) {
                                this.props.setMessageModal(true, this.props.getTranslation(resource.NOT_VALID_INVOICENUMBER));
                                return;
                            } else {
                                credits[0].OriginalInvoiceNumber = invoice.InvoiceNumber || originalInvoiceNumber.trim();
                                this.props.setInvoiceInfoModal(false, false, null, [], null);
                                this.props.createInvoice(this.props.invoiceModal.invoiceType, credits, reference);
                                this.closeWindow();
                            }
                        },
                        () => {
                            this.props.setMessageModal(true, this.props.getTranslation(resource.NOT_VALID_INVOICENUMBER));
                        }
                    );
                } else {
                    if (invoices.length > 0) {
                        this.props.createInvoice(this.props.invoiceModal.invoiceType, invoices, reference);
                    }
                    this.props.setInvoiceInfoModal(false, false, null, [], null);
                    this.closeWindow();
                }
            },
            [],
            null
        );
    }

    handleChange(e) {
        const item = e.target.name;

        var items = [...this.state.checkedItems];
        var index = items.indexOf(item);

        if (index !== -1) {
            items.splice(index, 1);
            this.setState({ checkedItems: items });
        } else {
            this.setState({ checkedItems: [...this.state.checkedItems, item] });
        }
    }

    toId(value) {
        if (value === null || value === undefined || value === '') {
            return '';
        }

        return value.toString();
    }

    findPosById(posId) {
        const target = this.toId(posId);
        return (this.props.posList || []).find(pos => this.toId(pos.PosId) === target) || null;
    }

    findStoreById(storeId) {
        const target = this.toId(storeId);
        return (this.props.storeList || []).find(store => this.toId(store.StoreId) === target) || null;
    }

    getStoreIdForReceipt(receipt) {
        const pos = this.findPosById(receipt.PosId);
        return pos ? this.toId(pos.StoreId) : '';
    }

    getCompanyIdForReceipt(receipt) {
        const store = this.findStoreById(this.getStoreIdForReceipt(receipt));
        return store ? this.toId(store.CompanyID) : '';
    }

    getStoresForSelectedCompany() {
        if (!this.state.selectedCompanyId) {
            return this.props.storeList || [];
        }
        return (this.props.storeList || []).filter(store => {
            return this.toId(store.CompanyID) === this.state.selectedCompanyId;
        });
    }

    getFilteredReceipts() {
        return (this.props.invoiceModal.receipts || []).filter(rec => {
            if (!this.state.selectedStoreId && !this.state.selectedCompanyId) {
                return true;
            }

            const receiptStoreId = this.toId(this.getStoreIdForReceipt(rec));
            const receiptCompanyId = this.toId(this.getCompanyIdForReceipt(rec));

            const matchesStore = !this.state.selectedStoreId || this.state.selectedStoreId === receiptStoreId;
            const matchesCompany = !this.state.selectedCompanyId || this.state.selectedCompanyId === receiptCompanyId;

            return matchesStore && matchesCompany;
        });
    }

    syncCheckedItemsWithVisibleReceipts() {
        const visibleReceiptIds = this.getFilteredReceipts().map(rec => rec.ReceiptId.toString());
        const filteredCheckedItems = this.state.checkedItems.filter(itemId => visibleReceiptIds.indexOf(itemId) !== -1);

        if (filteredCheckedItems.length !== this.state.checkedItems.length) {
            this.setState({ checkedItems: filteredCheckedItems });
        }
    }

    applyDefaultsFromPos() {
        const currentPos = this.findPosById(this.props.posId);
        const storeId = this.toId(currentPos ? currentPos.StoreId : '');
        const currentStore = this.findStoreById(storeId);
        const companyId = this.toId(currentStore ? currentStore.CompanyID : '');

        this.setState({
            selectedStoreId: storeId,
            selectedCompanyId: companyId,
            checkedItems: []
        });
    }

    handleStoreChange(e) {
        const selectedStoreId = e.target.value;
        const selectedStore = this.findStoreById(selectedStoreId);
        const selectedCompanyId = selectedStore ? this.toId(selectedStore.CompanyID) : this.state.selectedCompanyId;

        this.setState({ selectedStoreId, selectedCompanyId });
    }

    handleCompanyChange(e) {
        const selectedCompanyId = e.target.value;
        const filteredStores = !selectedCompanyId
            ? (this.props.storeList || [])
            : (this.props.storeList || []).filter(store => this.toId(store.CompanyID) === selectedCompanyId);
        const storeStillValid = !this.state.selectedStoreId || filteredStores.some(store => this.toId(store.StoreId) === this.state.selectedStoreId);

        this.setState({
            selectedCompanyId,
            selectedStoreId: storeStillValid ? this.state.selectedStoreId : ''
        });
    }

    render() {
        const filteredReceipts = this.getFilteredReceipts();
        const storeOptions = this.getStoresForSelectedCompany();
        const receipts = filteredReceipts.length === 0 ? [<label key="no-invoices-label">{this.props.getTranslation(resource.NO_AVAILABLE_INVOICES)}</label>]
            : filteredReceipts.map((rec, index) => {
                const checked = this.state.checkedItems.indexOf(rec.ReceiptId.toString()) !== -1;
                const isCredit = rec.Credit === true;

                return (
                    <div className="receiptInfo" key={index}>
                        <div className="check">
                            <input
                                type="checkbox"
                                name={rec.ReceiptId.toString()}
                                checked={checked}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className="details">
                            <div className="details-left">
                                <label>{this.props.getTranslation(resource.RECEIPT)}: {rec.ReceiptId}  {isCredit && ` (${this.props.getTranslation(resource.CREDIT)})`}</label>
                                <label>{this.props.getTranslation(resource.DATE)}: {Intl.DateTimeFormat('nl-NL').format(new Date(rec.ReceiptDateTime))}</label>
                            </div>
                            <div className="details-right">
                                {rec.Store && <label>{this.props.getTranslation(resource.STORE)}: {rec.Store}</label>}
                                {rec.Company && <label>{this.props.getTranslation(resource.COMPANY)}: {rec.Company}</label>}
                            </div>
                        </div>
                    </div>
                );
            });

        return (
            <Modal className='invoiceModal'
                contentLabel=""
                isOpen={!!this.props.invoiceModal.show}
                style={properties.invoiceModalStyle}
            >
                <div className="invoiceModal_header">
                    <div className="header_top">
                        {this.props.getTranslation(resource.TO_INVOICE)}
                        <button className="header_close" onClick={this.closeWindow}>
                            <i className="icon remove" />
                            <Ink />
                        </button>
                    </div>

                </div>
                <div className="invoiceModal_receipts">
                    <div className="invoiceModal_filters">
                        <div className="invoiceModal_filter">
                            <label>{this.props.getTranslation(resource.STORE)}</label>
                            <select value={this.state.selectedStoreId} onChange={this.handleStoreChange}>
                                <option value="">-</option>
                                {storeOptions.map((store, index) => {
                                    const storeId = this.toId(store.StoreId);
                                    const description = store.Description;
                                    return <option key={`store-${storeId || index}`} value={storeId}>{description}</option>;
                                })}
                            </select>
                        </div>
                        <div className="invoiceModal_filter">
                            <label>{this.props.getTranslation(resource.COMPANY)}</label>
                            <select value={this.state.selectedCompanyId} onChange={this.handleCompanyChange} disabled>
                                <option value="">-</option>
                                {(this.props.companyList || []).map((company, index) => {
                                    const companyId = this.toId(company.CompanyID);
                                    const description = company.Description;
                                    return <option key={`company-${companyId || index}`} value={companyId}>{description}</option>;
                                })}
                            </select>
                        </div>
                    </div>
                    <div id="receipts" className="invoiceModal_scrollable receipts">
                        {receipts}
                    </div>
                </div>
                <div className="invoiceModal_footer">
                    <div className="btnLeft">
                        <button className="btnCancel" onClick={this.closeWindow} >
                            {this.props.getTranslation(resource.CANCEL)}
                        </button>
                    </div>
                    <div className="btnRight">
                        <button className="btnInvoiceSelection" onClick={this.invoiceSelection} >
                            {this.props.getTranslation(resource.SELECTION)}
                        </button>
                        <button className="btnInvoiceAll" onClick={this.invoiceAll} >
                            {this.props.getTranslation(resource.EVERYTHING)}
                        </button>
                    </div>
                </div>
            </Modal>
        )
    }
}

InvoiceModal.propTypes = {
    invoiceModal: PropTypes.object.isRequired,
    posId: PropTypes.number.isRequired,
    posList: PropTypes.array.isRequired,
    storeList: PropTypes.array.isRequired,
    companyList: PropTypes.array.isRequired,
    setInvoiceModal: PropTypes.func.isRequired,
    createInvoice: PropTypes.func.isRequired,
    getTranslation: PropTypes.func.isRequired,
    getOriginalInvoice: PropTypes.func.isRequired,
    setMessageModal: PropTypes.func.isRequired,
    setInvoiceInfoModal: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        invoiceModal: state.modalState.invoiceModal,
        posId: state.generalState.posId,
        posList: state.generalState.posList,
        storeList: state.generalState.storeList,
        companyList: state.generalState.companyList
    }
}

export default connect(
    mapStateToProps,
    { setInvoiceModal, createInvoice, getTranslation, getOriginalInvoice, setMessageModal, setInvoiceInfoModal }
)(InvoiceModal)


// WEBPACK FOOTER //
// src/modal/components/InvoiceModal.jsx